import * as entity from '@common/domain/entities/SupplierFileCabinet'
import * as app from '@framework/app';
import { IFieldOptions, IDataEndPoint } from '../../../framework/interfaces/IEntity';
import { ViewType, FieldType } from '../../../framework/core/Enums';
import { appSettings } from '@shared/components/appSettings';
import { IApiServiceCommand } from '../../../services/api/api.service';
import { FormBuilderControlListHelper } from '../../formbuilder/FormBuilderControlListHelper';
export class SupplierFileCabinetEndPoints extends entity.SupplierFileCabinetEndPoints {
  list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/supplierFileCabinet/perRequisition/" + serviceCommand.context.entityId }, method: "GET" };
  update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/supplierFileCabinet/updateWithFile/" + serviceCommand.context.entityId }, method: "POST" };
  insert?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      debugger;
      return app.config.controllerRouteRoot + "/supplierFileCabinet/createWithFile/" + serviceCommand.context.parent.previousEntityId
    }, method: "POST"
  };
  get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/supplierFileCabinet/withFile/" + serviceCommand.context.entityId }, method: "GET" };
  search?: IDataEndPoint = null;
}

export class SupplierFileCabinetFormFields extends entity.SupplierFileCabinetFormFields {
  constructor() {
    super();
	 try {
      if (this["id"]) this.splice(this.indexOf(this["id"]), 1)
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
       if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)


       this.fileCabinetId.required = true;
       this.splice(0, this.length)
       let file: IFieldOptions = {
         field: "file", required: true, viewType: ViewType.File, fieldType: FieldType.String, name: "File", dataDisplayField: "fileName", dataIdField: "fileCabinetId",
         dataEndPoint: { url: appSettings.apiServiceAddress + "/api/filecabinetDocument/download/", method: "POST" },
         insertEndPoint: { url: appSettings.apiServiceAddress + "/api/filecabinetDocument/uploadNewFiles", method: "POST" },
       };
       let description: IFieldOptions = { field: "description", fieldType: FieldType.String, name: "Description" };
       description.viewType = ViewType.Text;

       this.supplierFileCabinetTypeId.name = "Document Type";
       this.supplierFileCabinetTypeId.viewType = ViewType.Dropdown;
       this.supplierFileCabinetTypeId.dataEndPoint = { url: app.config.controllerRouteRoot + "/supplierFileCabinetType" };
       this.supplierFileCabinetTypeId.dataDisplayField = "description";
       this.supplierFileCabinetTypeId.dataIdField = "id";
       this.supplierFileCabinetTypeId.required = true;
       this.expiryDate.viewType = ViewType.Date;
       this.push(file)
       this.push(this.supplierFileCabinetTypeId)
       this.push(this.expiryDate)
       
       this.push(description)
    } catch  { }
  }
}

export class SupplierFileCabinetForm extends entity.SupplierFileCabinetForm {
  protected supplierFileCabinetFormEndPoints: SupplierFileCabinetEndPoints = new SupplierFileCabinetEndPoints();
  protected supplierFileCabinetFormFields: SupplierFileCabinetFormFields = new SupplierFileCabinetFormFields();
  public canDelete?: boolean = true;
}

export class SupplierFileCabinetListColumns extends entity.SupplierFileCabinetListColumns {
  constructor() {
    super();
	    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
          if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
          if (this["status"]) this.splice(this.indexOf(this["status"]), 1)
          if (this["supplierId"]) this.splice(this.indexOf(this["supplierId"]), 1)
          if (this["supplierFileCabinetTypeId"]) this.splice(this.indexOf(this["supplierFileCabinetTypeId"]), 1)
          this.splice(0, this.length);
          this.fileCabinetId.visible = false;


          this.push(FormBuilderControlListHelper.getListColumn("expiryDate", "Expiry Date", null, null, "expiryDate"));
          this.push(FormBuilderControlListHelper.getListColumn("fileCabinet.description", "Type", null, null, "supplierFileCabinetTypeDescription"));
          let file: IFieldOptions = FormBuilderControlListHelper.getListColumn("fileCabinet.fileName", "Filename", null, null, "fileName");
          // this.push(FormBuilderControlListHelper.getListColumn("fileCabinet.fileName", "Filename", null, null, "fileCabinet_fileName"));
          this.push(FormBuilderControlListHelper.getListColumn("supplierFileCabinetType.Description", "Description", null, null, "description"));

          this.expiryDate.viewType = ViewType.Date;
          //file.viewType = ViewType.File;
          //file.formBuilderControl.controlType.viewType = ViewType.File;
          //file.dataDisplayField = "fileName";
          //file.dataIdField = "fileCabinetId",
          //  file.dataEndPoint = { url: appSettings.apiServiceAddress + "/api/filecabinetDocument/download/", method: "POST" };
          //file.insertEndPoint = { url: appSettings.apiServiceAddress + "/api/filecabinetDocument/uploadNewFiles", method: "POST" };
          //file.readOnly = false;
          //this.push(file);
    } catch  { }
  }
}

export class SupplierFileCabinetList extends entity.SupplierFileCabinetList {
  protected supplierFileCabinetListEndPoints: SupplierFileCabinetEndPoints = new SupplierFileCabinetEndPoints();
  protected supplierFileCabinetListColumns: SupplierFileCabinetListColumns = new SupplierFileCabinetListColumns();
}

export class BladeSetup {
  public onSaveEvent = function (prop) {
    if (prop.listIndex == 0) {
      prop.parent.parent.getBladeByIndex(1).reloadFormByIndex(1);
    }
  }
  public onFormLoad: Function = function (data: any, formIndex?: any, context?: any) {

  }
}
